<script setup lang="ts">
defineProps(['params'])

const statusConfig: Record<string, { label: string; class: string }> = {
  PENDING: { label: 'En attente', class: 'bg-blue-100' },
  COMPLETED: { label: 'Terminé', class: 'bg-emerald-100' },
  CANCELLED: { label: 'Annulé', class: 'bg-red-100' },
}

function getStatusLabel(status: string) {
  return statusConfig[status]?.label || status
}

function getStatusClass(status: string) {
  return statusConfig[status]?.class || 'badge-ghost'
}
</script>

<template>
  <div class="flex items-center gap-2 w-full">
    <div class="w-fit">
      <span class="badge" :class="getStatusClass(params.data.status)">
        {{ getStatusLabel(params.data.status) }}
      </span>
    </div>
  </div>
</template>

<style scoped></style>
